import React, { Component, Fragment } from 'react';
import FormInputText from '../../../_shared/forms/FormInputText';
import SearchableSelect from '../../../_shared/forms/FormMultiSelect';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';
import FormCheckbox from '../../../_shared/forms/FormCheckbox';

export default class CustomerDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Customer Details</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            classes="form-control"
                            name="customer_id"
                            value={this.props.customer}
                            label="customer"
                            disabled
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            classes="form-control"
                            name="customer_contact"
                            value={this.props.customer_contact}
                            label="contact"
                            disabled
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            classes="form-control"
                            name="job_source_id"
                            value={this.props.job_source}
                            label="job source"
                            disabled
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            label="Purchase Order Number"
                            name="purchase_order_number"
                            type="text"
                            classes="form-control"
                            value={this.props.purchase_order_number}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputNumber
                            type="number"
                            label="SLA"
                            name="sla"
                            step="1"
                            min="1"
                            classes="form-control"
                            value={this.props.sla}
                            handleChange={this.props.handleChange}
                        />
                        <FormCheckbox
                            name="excluded_from_sla"
                            label="EXCLUDE FROM SLA"
                            checked={this.props.excluded_from_sla === 'yes'}
                            handleChange={this.props.handleChange}
                        />
                        {this.props.excluded_from_sla === 'yes' ? (
                            <FormInputText
                                label="Reason for Excluding from SLA"
                                hideLabel
                                name="excluded_from_sla_reason"
                                type="text"
                                classes={
                                    this.props.errors && this.props.errors.excluded_from_sla_reason
                                        ? 'form-control is-invalid'
                                        : 'form-control'
                                }
                                value={this.props.excluded_from_sla_reason}
                                handleChange={this.props.handleChange}
                                error={this.props.errors && this.props.errors.excluded_from_sla_reason}
                            />
                        ) : (
                            ''
                        )}
                    </div>

                    <div className="form-group col-md-4">
                        <FormInputText
                            label="department"
                            name="department"
                            type="text"
                            classes="form-control"
                            value={this.props.department}
                            disabled
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            label="Purchase Order Total"
                            name="purchase_order_total"
                            type="text"
                            classes="form-control"
                            value={this.props.purchase_order_total}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}
